import { render, staticRenderFns } from "./SocialButtons.vue?vue&type=template&id=3324c4af&scoped=true&"
import script from "./SocialButtons.vue?vue&type=script&lang=js&"
export * from "./SocialButtons.vue?vue&type=script&lang=js&"
import style0 from "./SocialButtons.vue?vue&type=style&index=0&id=3324c4af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3324c4af",
  null
  
)

export default component.exports